import { Component, Input, OnInit, Renderer2, ViewEncapsulation } from "@angular/core";
import { EneIconService } from "./icon.service";

/**
 * @deprecated Use `tpm-icon` (`shared/ui/icon/`, wraps `gp-icon`) with a `gpi-*` icon.
 */
// tslint:disable: no-input-rename
// tslint:disable: no-host-metadata-property
@Component({
  selector: "ene-icon",
  templateUrl: "./icon.component.html",
  styleUrls: ["./icon.component.scss"],
  encapsulation: ViewEncapsulation.None,
  host: {
    class: "ene-icon",
    "[class]": "_hostClass",
    "[class.style-circle]": "circle",
    "[class.color-primary]": "primary",
    "[class.color-secondary]": "secondary",
    "[class.has-dropdown]": "dropdown",
    "[style.fontSize]": "size"
  }
})
export class EneIconComponent implements OnInit {
  @Input() public icon: string | undefined;

  @Input("class") public hostClass = "";
  @Input() public primary = false;
  @Input() public secondary = false;
  @Input() public circle = false;
  @Input() public dropdown = false;
  @Input() public notifications = 0;
  @Input() public project = "energycity";
  @Input() public size: string | null = null;

  public _hostClass: string | null = null;

  public animateNotification = false;
  public animateInit = true;

  constructor(private iconService: EneIconService, private renderer: Renderer2) {}

  public ngOnInit(): void {
    this._hostClass = `${this.hostClass} ${this.project}`;
    // register project in iconService and set boolean with the result if already set or not
    this.iconService.initIconFont(this.project, this.renderer);

    if (!this.icon) {
      console.error("No icon specified!");
    }
  }

  /**
   * Will be called after a CSS3 animation is completed.
   * It ensures to remove animation-classes so it can be reanimated if the notifications changed.
   */
  public onAnimationEnd(): void {
    this.animateNotification = false;
    this.animateInit = false;
  }
}
